<script>
  import { format } from 'svelte-i18n';
  import { Button, Modal, ModalBody, ModalFooter } from '@sveltestrap/sveltestrap';

  import { Icon } from '@client/components/icon';
  import { Spinner } from '@client/components/spinner';

  import { BizCardsService } from '@client/services/bizcards';
  import { BizCardsRoutingService } from '@client/services/bizcards-routing';

  import { deepCopy } from '@common/utils/objects';

  import { BizCardRouteForm } from '../shared';

  export let route = {};
  export let show = false;
  export let senderGroups = [];
  export let groupOptions = [];
  export let businessCardOptions = [];
  export let onAdd = () => {};
  export let updatePriorityPositions = () => {};
  export let priority = [];

  let originalRoute = deepCopy(route);
  let isUpdating = false;
  let filterText = '';

  const onSave = async () => {
    isUpdating = true;

    const selectedGroups = (route.selectedGroups || []).map(({ value }) => value);
    const sendergroups = senderGroups.filter(({ groupname }) => selectedGroups.includes(groupname));
    const { blockname, status, bizcard = {}, _id } = route;
    const isNewRoute = _id === undefined;

    const payload = {
      blockname,
      bizcard,
      priority: route.priority,
      sendergroups,
      status: route.status,
      tags: []
    };

    if (!isNewRoute) {
      payload._id = _id;
      payload.priority = payload.priority - 1;
    }

    const response = await BizCardsRoutingService.updateRoute(payload);
    const sgroups = senderGroups.filter(
      ({ groupname }) => sendergroups.filter((group) => groupname === group.groupname).length
    );

    route = {
      ...response,
      ...route,
      selectedGroups: route.selectedGroups || [],
      sendergroups: sgroups,
      status: route.status,
      editing: false
    };

    if (isNewRoute) {
      priority.push(route);
      priority = updatePriorityPositions(priority, priority.length - 1, 0);
      await onAdd();
    }

    priority = priority.map((item) => (!item._id || item?._id === route._id ? route : item));

    route = null;
    show = false;
    isUpdating = false;
  };

  const onCancel = () => {
    route = null;
    show = false;
  };

  const onSignatureChange = async (e) => {
    const blockname = e.detail.value;
    const response = await BizCardsService.getById(blockname);

    route = {
      ...route,
      bizcard: response,
      blockname
    };
  };

  const onUpdateHandler = () => onUpdate(route);
</script>

<Modal bind:isOpen={show} size="md" fullscreen="md" aria-labelledby="modal-title" role="dialog">
  <ModalBody class="edit-route">
    <Spinner show={isUpdating} backdrop />
    <div class="edit-route-container">
      <button class="close" on:click={onCancel} aria-label="Close modal" tabindex="0">
        <Icon name="x" aria-hidden="true" />
      </button>

      <div class="heading">
        <h1 id="modal-title">
          {#if route._id}
            {$format('label.EDIT_ROUTE')} #{route.priority}
          {:else}
            {$format('label.CREATE_ROUTE')}
          {/if}
        </h1>
      </div>

      <div class="form">
        <BizCardRouteForm bind:route bind:businessCardOptions bind:groupOptions {onSignatureChange} />
      </div>
    </div>
  </ModalBody>
  <ModalFooter class="border-top p-4 mt-2">
    <Button color="link" on:click={onCancel}>
      {$format('label.CANCEL')}
    </Button>
    <Button color="primary" on:click={onSave}>
      {#if route._id}
        {$format('label.UPDATE')}
      {:else}
        {$format('label.SAVE')}
      {/if}
    </Button>
  </ModalFooter>
</Modal>

<style lang="scss" src="./edit.scss"></style>
